import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectBusinessPartnerModel from '../../../models/ProjectBusinessPartnerModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddProjectPopup from '../Popups/BusinessPartner_popup_AddProject';

const BusinessPartner_tab_Projects: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<ProjectBusinessPartnerModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<ProjectBusinessPartnerModel[]>('api/v1/ProjectBusinessPartners/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: ProjectBusinessPartnerModel) {
        DataService.delete('api/v1/ProjectBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'projectId', visible: false },
        { title: 'Project', dataProp: 'project', dataType: 'project', sort: 'asc' },
        { title: 'Project type', dataProp: 'project.projectType.name' },
        { title: 'Status', dataProp: 'project.projectStatus.name' },
        { title: 'Started on', dataProp: 'project.startedOn', dataType: 'date' },
        { title: 'Deadline', dataProp: 'project.deadline', dataType: 'date' },
        { title: 'Finished on', dataProp: 'project.finishedOn', dataType: 'date' },
    ];

    const { isAuthorizedFor } = useAuth();
    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerProjects'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Project'
                navigateUrl='/plm/Projects/Details/'
            />
            <AddProjectPopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />
        </>
    );
}
export default BusinessPartner_tab_Projects;